import { isNotEmptyArray } from '@vy/utils';
import type { FilterLineType } from '../../../components/new-design/vyTableFilter';

export type FilterPredicate<TRow> = (row: TRow, value: unknown) => boolean;
export type FilterPredicateMap<TRow> = Record<string, FilterPredicate<TRow>>;

export function applyReportFilters<TRow>(
  rows: TRow[],
  filters: FilterLineType[],
  predicates: FilterPredicateMap<TRow>,
): TRow[] {
  if (!isNotEmptyArray(filters)) {
    return rows;
  }

  return rows.filter((row) =>
    filters.every((filter) => {
      const predicate = predicates[filter.field];
      if (!predicate) return true;
      return predicate(row, filter.value);
    }),
  );
}
